/**
 * Account Form Fields Component
 *
 * Renders form fields for account creation/editing.
 */

import React from 'react';
import { Input, Select, SelectItem } from '@heroui/react';
import type { AccountFormData } from '../model/types';

interface AccountFormFieldsProps {
  formData: AccountFormData;
  onUpdate: (data: Partial<AccountFormData>) => void;
  mode: 'add' | 'edit';
  className?: string;
}

export const AccountFormFields: React.FC<AccountFormFieldsProps> = ({
  formData,
  onUpdate,
  mode,
  className = '',
}) => {
  return (
    <div className={`space-y-4 ${className}`}>
      <div>
        <Select
          label="플랫폼"
          selectedKeys={[formData.platform]}
          onSelectionChange={(keys) =>
            onUpdate({ platform: Array.from(keys)[0] as AccountFormData['platform'] })
          }
        >
          <SelectItem key="INSTAGRAM">Instagram</SelectItem>
          <SelectItem key="YOUTUBE">YouTube</SelectItem>
          <SelectItem key="TIKTOK">TikTok</SelectItem>
        </Select>
      </div>

      <div>
        <Input
          type="text"
          label="계정 ID"
          value={formData.account_id}
          onChange={(e) => onUpdate({ account_id: e.target.value })}
          placeholder="계정 ID를 입력하세요"
        />
      </div>

      <div>
        <Input
          type="password"
          label={mode === 'edit' ? '비밀번호 (변경시에만 입력)' : '비밀번호'}
          value={formData.password}
          onChange={(e) => onUpdate({ password: e.target.value })}
          placeholder={mode === 'edit' ? '비밀번호 변경시에만 입력' : '비밀번호를 입력하세요'}
        />
      </div>
    </div>
  );
};

AccountFormFields.displayName = 'AccountFormFields';
